import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g
        data-name="Layer 1"
        stroke="fj-icons-primary-color"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M24.53 40.5V26c0-4.54-4.08-8.25-9.07-8.25h-5.9C4.58 17.77.5 21.48.5 26v14.5z"
          strokeWidth={1}
          fill="fj-icons-bg-color"
        />
        <ellipse cx={12.51} cy={9.45} rx={8.8} ry={8.95} strokeWidth={1} fill="fj-icons-bg-color" />
        <rect
          x={17.15}
          y={17.15}
          width={20}
          height={26.7}
          rx={0.67}
          ry={0.67}
          transform="rotate(90 27.15 30.5)"
          strokeWidth={1}
          fill="fj-icons-bg-color"
        />
        <path
          strokeWidth={0.75}
          fill="fj-icons-bg-color"
          d="M34.7 34.86v4.33l1.89-2.17 1.89 2.17v-4.33H34.7z"
        />
        <circle cx={36.59} cy={33.37} r={2.52} strokeWidth={0.75} fill="fj-icons-bg-color" />
        <path
          fill="none"
          strokeWidth={0.5}
          d="M16.25 23.63h22.03M16.25 25.47h22.03M16.25 27.31h22.03M16.25 29.16h22.03M16.25 34.94h10.01M16.25 36.66h10.01"
        />
      </g>
    </g>
  </svg>
);

const IndividualLicense = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default IndividualLicense;
